export default "__VITE_ASSET__CsYX9Vof__"